// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"353":"contact","461":"skills","597":"projects"}[chunkId] + "." + {"353":"6561451e","461":"00a5a44c","597":"4f19082f"}[chunkId] + ".chunk.js";
};